module.exports = __webpack_public_path__ + "img/cooperate_25.ad6fdef8.png";